import { render } from "./BookingFormComponent.vue?vue&type=template&id=d6d49260&scoped=true"
import script from "./BookingFormComponent.vue?vue&type=script&lang=ts"
export * from "./BookingFormComponent.vue?vue&type=script&lang=ts"

import "./BookingFormComponent.vue?vue&type=style&index=0&id=d6d49260&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d6d49260"

export default script